// Il server lavora in UTC. Dapper serializza i DATETIME senza offset,
// quindi va marcato esplicitamente come UTC prima di renderlo in locale.
export function utcToLocalDate(s) {
  if (!s) return null;
  const iso = s.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(s) ? s : s + 'Z';
  return new Date(iso);
}

export function formatLocale(s) {
  const d = utcToLocalDate(s);
  return d ? d.toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '';
}

// input datetime-local ("2026-08-05T18:00") -> UTC per il backend
export function localInputToUtc(v) {
  if (!v) return null;
  return new Date(v).toISOString().slice(0, 19);
}
